// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__2WF_Q","vLegacy":"SelectSecondary_vLegacy__1j135","error":"SelectSecondary_error__3Y7mK","disabled":"SelectSecondary_disabled__3j3Em"};